import { useEffect, useState } from "react";
import mentorshipMale from "./mentorship-male.png";
import mentorshipFemale from "./mentorship-female.png";
import mentorshipMixed from "./mentorship-mixed.png";

const images = [mentorshipMale, mentorshipFemale, mentorshipMixed];

export function Welcome() {
  const [index, setIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => setIndex((i) => (i + 1) % images.length), 5000);
    return () => clearInterval(interval);
  }, []);

  return (
    <main className="flex items-center justify-center min-h-screen bg-gray-50 dark:bg-gray-900">
      <div className="relative w-full max-w-6xl">
      <h1 className="text-5xl font-bold text-center">Atila</h1>
      <h2 className="text-2xl text-center">Meet Mentors. Get a Job. Create a Job.</h2>
        <img src={images[index]} className="WelcomeImage w-full h-[500px] rounded-lg shadow-xl" />
        <Dots index={index} setIndex={setIndex} />
      </div>
    </main>
  );
}

const Dots = ({ index, setIndex }: { index: number; setIndex: (index: number) => void }) => (
  <div className="absolute bottom-4 left-1/2 -translate-x-1/2 flex gap-2">
    {images.map((_, i) => (
      <button
        key={i}
        onClick={() => setIndex(i)}
        className={`w-3 h-3 rounded-full ${i === index ? "bg-white" : "bg-white/50"}`}
      />
    ))}
  </div>
);
